import useAppointmentMeta from '@components/Clinicians/Session/hooks/useAppointmentMeta';

const DEFAULT_ORDER = [
  {
    note_code: 'DIAGNOSIS',
    mandatory: 1,
    display_order: 10
  },
  {
    note_code: 'HPC',
    mandatory: 1,
    display_order: 20
  },
  {
    note_code: 'PLAN',
    mandatory: 1,
    display_order: 40
  },
  {
    note_code: 'RECOMMENDATIONS',
    mandatory: 0,
    display_order: 40
  },
  {
    note_code: 'WD',
    mandatory: 0,
    display_order: 50
  },
  {
    note_code: 'FACTSHEET',
    mandatory: 0,
    display_order: 60
  },
  {
    note_code: 'D-COM',
    mandatory: 0,
    display_order: 70
  },
  {
    note_code: 'INT',
    mandatory: 0,
    display_order: 80
  }
] as const;

type NoteCode =
  'DIAGNOSIS' | 'HPC' | 'IMPRO' | 'PLAN' | 'WD' | 'D-COM' | 'FACTSHEET' | 'INT' | 'UPDATE' | 'RECOMMENDATIONS';

const DEFAULT_LABELS: Record<NoteCode, string> = {
  DIAGNOSIS: 'Diagnosis',
  HPC: 'Presenting Condition',
  IMPRO: 'Improvement Status:',
  PLAN: 'Agreed plan',
  WD: 'Impression',
  'D-COM': 'Additional comments',
  FACTSHEET: 'Factsheets',
  INT: 'Internal clinical notes (shared with clinicians ONLY)',
  UPDATE: 'Update',
  RECOMMENDATIONS: 'Recommendations'
};

const useClinicalNotesMeta = () => {
  const { data: appointmentsMeta } = useAppointmentMeta();

  const notesMeta = appointmentsMeta?.appt_type_notes || DEFAULT_ORDER;

  const notesOrder = notesMeta
    .slice()
    .sort((a, b) => a.display_order - b.display_order)
    .map((note) => note.note_code);

  const mandatoryMap = new Map(notesMeta.map((note) => [note.note_code, Boolean(note.mandatory)]));

  const noteLabelMap = new Map(
    notesMeta.map((note) => [note.note_code, 'notes_desc' in note ? note.notes_desc : null])
  );

  const getIsFieldRequired = (noteCode: NoteCode): boolean => mandatoryMap.get(noteCode) || false;

  const getNoteLabel = (noteCode: NoteCode): string => noteLabelMap.get(noteCode) || DEFAULT_LABELS[noteCode];

  return {
    notesOrder,
    getIsFieldRequired,
    getNoteLabel
  };
};

export default useClinicalNotesMeta;
